import client from "../../../api/client";

// Student course page (LMS revamp) — see StudentCourseController / StudentLessonController.
// cohort_id matters when the same course is taken in two cohorts (e.g. beta and Pioneer).
export const getPlan = (uuid, cohortId) => client.get(`/me/courses/${uuid}/plan`, { params: cohortId ? { cohort_id: cohortId } : {} }).then((r) => r.data);

export const saveWatch = (lessonId, body) => client.post(`/me/lessons/${lessonId}/watch`, body).then((r) => r.data);

/** kind: "assignment" | "project". fields: { method, file?, answer_text?, file_link?, title? } */
export const submitFinal = (kind, id, fields, startedAt) => {
  const form = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach((x) => form.append(`${k}[]`, x));
    else if (v !== undefined && v !== null && v !== "") form.append(k, v);
  });
  form.append("form_started_at", String(startedAt)); // bot guard: forms filled in under 3s are rejected
  return client.post(`/me/${kind === "project" ? "projects" : "assignments"}/${id}/submit`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

export const errorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const data = err?.response?.data;
  if (data?.errors) return Object.values(data.errors).flat()[0];
  return data?.message || fallback;
};
